import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { createCompatibleRandomId } from '../../../../core/helpers/native-random';

@Pipe({
    name: 'filterEventsForElement',
    standalone: false
})
export class FilterEventsForElementPipe implements PipeTransform {
  transform(value: Observable<any>, id: string): Observable<any> {
    return value.pipe(
      tap((x) => console.log(x, id)),
      filter((v) => v === id),
      map(() => createCompatibleRandomId()),
    );
  }
}
